import { useEffect, useState } from "react";
import { _DashBoard } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { DashBoardViewer } from "./DashBoardViewer";

export const DashBoardAccount = () => {

    const _dashBoar = useDataBean(_DashBoard);
    const { bean, setBean, lista, setLista, instance, handleChange } = _dashBoar;
    const [report, setReport] = useState<any>({});
    const [tablero, setTablero] = useState<any>([]);

    useEffect(() => {
        getDashBoardInfo();
    }, [])

    useEffect(() => {
        console.log(bean.Tablero);
        
        let t = lista.filter(item => item.DataBeanProperties.IDDashBoard == bean.Tablero);
        if (t.length > 0)
            setTablero(t[0]);
    }, [bean])


    const getDashBoardInfo = () => {

        instance.getDashBoardCatalog(null, null, null, _single.getAccountID(), 1, 100).then(
            (resp: any) => {

                setLista(resp.List);
                if (resp.List.length > 0) {
                    setTablero(resp.List[0].DataBeanProperties);
                }

            }
        )

    }

    const setIDTablero =()=>{

    }


    return (
        <BasicPage titulo="BashBoard">
            <div className="row">
                <div className="col-md-8">
                    <label>Tablero</label>
                    <select name="Tablero" id="Tablero" className="form-select" value={bean.Tablero} onChange={(e)=>{setBean({...bean,"Tablero":parseInt(e.target.value)})}}>
                        {lista.map((row, index) => {
                            return (
                                <option key={index} value={row.DataBeanProperties.IDDashBoard}>{row.DataBeanProperties.Name}</option>
                            )
                        })}
                    </select>
                </div>
                
                <div className="col-md-12">
                    {tablero.IDDashBoard &&
                        <DashBoardViewer idKpi={tablero.IDDashBoard}  kpi={tablero} xint={3} yint={5} />
                    }
                    {/* <PrintJson json={tablero.DataBeanProperties} /> */}
                </div>
            </div>
        </BasicPage>
    )
}